@import "stylesheets/sdx/utilities/color";
@import "stylesheets/sdx/utilities/screenreaders";
@import "stylesheets/sdx/icons";

:host {
  display: inline-block;
}

:host(.size) {
  line-height: 1; // same as stylesheets/sdx/mixins/_icon.scss
}
